import { render, staticRenderFns } from "./CustomGridTab.vue?vue&type=template&id=561fb138&"
import script from "./CustomGridTab.vue?vue&type=script&lang=ts&"
export * from "./CustomGridTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports